
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/legal/[legalPageSlug]",
      function () {
        return require("private-next-pages/legal/[legalPageSlug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/legal/[legalPageSlug]"])
      });
    }
  